"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetStatusFilter = void 0;
const react_1 = __importStar(require("react"));
const AssetStatusFilter_1 = require("decentraland-ui/dist/components/AssetStatusFilter");
const utils_1 = require("../../modules/translation/utils");
const AssetStatusFilter = (props) => {
    const i18n = (0, react_1.useMemo)(() => ({
        title: (0, utils_1.t)('@dapps.asset_status_filter.title'),
        status: {
            [AssetStatusFilter_1.AssetStatus.NOT_FOR_SALE]: (0, utils_1.t)('@dapps.asset_status_filter.not_for_sale'),
            [AssetStatusFilter_1.AssetStatus.ONLY_LISTING]: (0, utils_1.t)('@dapps.asset_status_filter.only_listing'),
            [AssetStatusFilter_1.AssetStatus.ONLY_MINTING]: (0, utils_1.t)('@dapps.asset_status_filter.only_minting'),
            [AssetStatusFilter_1.AssetStatus.ON_SALE]: (0, utils_1.t)('@dapps.asset_status_filter.on_sale')
        },
        tooltips: {
            [AssetStatusFilter_1.AssetStatus.NOT_FOR_SALE]: (0, utils_1.t)('@dapps.asset_status_filter.not_for_sale_tooltip'),
            [AssetStatusFilter_1.AssetStatus.ONLY_LISTING]: (0, utils_1.t)('@dapps.asset_status_filter.only_listing_tooltip'),
            [AssetStatusFilter_1.AssetStatus.ONLY_MINTING]: (0, utils_1.t)('@dapps.asset_status_filter.only_minting_tooltip'),
            [AssetStatusFilter_1.AssetStatus.ON_SALE]: (0, utils_1.t)('@dapps.asset_status_filter.on_sale_tooltip')
        }
    }), []);
    return react_1.default.createElement(AssetStatusFilter_1.AssetStatusFilter, Object.assign({ i18n: i18n }, props));
};
exports.AssetStatusFilter = AssetStatusFilter;
//# sourceMappingURL=AssetStatusFilter.js.map